import axios from "axios";

const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
// Defensive guard: if someone mis-configured REACT_APP_BACKEND_URL to point at the
// marketing site (sproutsedutours.in) or another non-API host, fall back to same-origin.
// The Emergent deployment proxies /api on whatever domain you're visiting, so "" is safe.
const BACKEND_URL = /sproutsedutours\.in/i.test(RAW_BACKEND_URL) ? "" : RAW_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "SPROUTS_ADMIN_TOKEN";
const EMAIL_KEY = "SPROUTS_ADMIN_EMAIL";

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const getAuthEmail = () => localStorage.getItem(EMAIL_KEY) || "";
export const setAuthToken = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EMAIL_KEY, email);
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

const client = axios.create({ baseURL: API_BASE, headers: { "Content-Type": "application/json" } });

client.interceptors.request.use((cfg) => {
  if (cfg._auth) {
    const token = getAuthToken();
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

const unwrap = (p) =>
  p
    .then((r) => r.data)
    .catch((err) => {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : err?.message || "Request failed";
      throw new Error(msg);
    });

export const api = {
  // Public
  stats: () => unwrap(client.get("/stats")),
  approvedSchools: () => unwrap(client.get("/schools/approved")),
  registerSchool: (data) => unwrap(client.post("/schools/register", data)),
  submitEntry: (data) => unwrap(client.post("/entries", data)),

  // Admin
  adminLogin: (email, password) => unwrap(client.post("/admin/login", { email, password })),
  adminMe: () => unwrap(client.get("/admin/me", { _auth: true })),
  adminSchools: (status) =>
    unwrap(client.get(`/admin/schools${status ? `?status=${status}` : ""}`, { _auth: true })),
  adminUpdateSchoolStatus: (id, status) =>
    unwrap(client.patch(`/admin/schools/${id}/status`, { status }, { _auth: true })),
  adminUpdateSchool: (id, data) => unwrap(client.put(`/admin/schools/${id}`, data, { _auth: true })),
  adminDeleteSchool: (id) => unwrap(client.delete(`/admin/schools/${id}`, { _auth: true })),
  adminEntries: (filters = {}) => {
    const qs = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v) qs.append(k, v);
    });
    const q = qs.toString();
    return unwrap(client.get(`/admin/entries${q ? `?${q}` : ""}`, { _auth: true }));
  },
  adminDeleteEntry: (id) => unwrap(client.delete(`/admin/entries/${id}`, { _auth: true })),
};

// CSV download helper – returns blob with Bearer header (admin only)
export async function downloadCsv(kind) {
  const url = kind === "schools" ? `${API_BASE}/admin/schools/export` : `${API_BASE}/admin/entries/export`;
  const fname = kind === "schools" ? "sprouts_schools.csv" : "sprouts_entries.csv";
  const res = await fetch(url, { headers: { Authorization: `Bearer ${getAuthToken()}` } });
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  const blob = await res.blob();
  const dl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = dl;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(dl);
}
